import { UrlHelper } from '@/common/helper/url-helper-service'
import { HttpHelper } from '@/common/helper/http-helper-service'
import { constants } from '@/common/constant/constants';

export default class ServiceProviderServices {
    constructor() {
    }

    static saveServiceProvider = (params: object) => {
        let url = constants.apiUrl.serviceProviderUrls.createServiceProvider;
        url = UrlHelper.getUrl(url);
        return HttpHelper.postData(url, params);
    }

    static validateServiceProvider = (params: object) => {
        let url = UrlHelper.getUrl(constants.apiUrl.serviceProviderUrls.validateserviceprovider);
        return HttpHelper.postData(url, params);
    }

    static sendOTP = (params: object) => {
        let url = UrlHelper.getUrl(constants.apiUrl.serviceProviderUrls.sendotp);
        return HttpHelper.postData(url, params);
    }

    static verifyOTP = (params: object) => {
        let url = UrlHelper.getUrl(constants.apiUrl.serviceProviderUrls.verifyotp);
        return HttpHelper.postData(url, params);
    }

    static getServieproviderTimeZoneList = () => {
        return HttpHelper.getData(constants.apiUrl.serviceProviderUrls.getTimeZoneAzureFunction);
    }
}
